import settingsActionCreatorFactory from 'typescript-fsa'
import { Theme } from '@mui/material'
import { Message } from '@professocial/professocialTypes/types/messageTypes'
import { ActionCall } from '@professocial/professocialTypes/types'

export const commonActionCreator = settingsActionCreatorFactory('SETTINGS')

/**
 * Actions
 */

// common actions
export const setTheme = commonActionCreator<Theme>('SET_THEME')
export const setUser = commonActionCreator<any>('SET_USER')
export const setLanguage = commonActionCreator<any>('SET_LANGUAGE')
export const setMessage = commonActionCreator<Message>('SET_MESSAGE')

export const requestStarted = commonActionCreator<ActionCall>('REQUEST_STARTED')
export const requestFinished = commonActionCreator<ActionCall>('REQUEST_FINISHED')
export const requestFailed = commonActionCreator<ActionCall>('REQUEST_FAILED')
export const clearRequests = commonActionCreator('CLEAR_REQUESTS')
